import { isEditorialPage } from 'models/EditorialPageModel';
import { PageState } from 'models/PageState';

export const getEditorials = ({ currentPage }: PageState) =>
  isEditorialPage(currentPage) ? currentPage.editorials : [];

export const getMenu = ({ currentPage }: PageState) =>
  isEditorialPage(currentPage) ? currentPage.menu : [];

export const getTotalCount = ({ currentPage }: PageState) =>
  isEditorialPage(currentPage) ? currentPage.totalCount : 0;

export const getNextPage = ({ currentPage }: PageState) =>
  isEditorialPage(currentPage) ? currentPage.nextPage : 0;
